<template>
  <footer
    id="main-footer"
    class="bg-float-default-low text-static-default-hi relative p-32"
  >
    <div class="mx-auto lg:w-[1120px]">
      <FooterEmailCollector v-if="FF_ENABLE_FOOTER_EMAIL_COLLECTOR" />

      <ul class="flex list-none flex-col gap-32 md:flex-row">
        <li
          v-for="(footerCategory, index) in footerCategories"
          :key="index"
          class="md:basis-full"
        >
          <h2 v-if="footerCategory.title" class="heading-3 mb-16">
            {{ i18n(footerCategory.title) }}
          </h2>
          <FooterCategory :content="footerCategory.content" />
        </li>
      </ul>
      <RevDivider class="my-20" />
      <div
        class="flex flex-col items-center justify-between gap-12 pt-20 lg:flex-row"
      >
        <FooterCompanyDisclaimer />
        <AppStoreButtons
          campaign="footer"
          tracking-zone="front_office_footer"
        />
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { useRuntimeConfig } from '#imports'

import AppStoreButtons from '@backmarket/nuxt-layer-base/components/AppStoreButtons/AppStoreButtons.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDivider } from '@ds/components/Divider'

import FooterCategory from './FooterCategory.vue'
import FooterCompanyDisclaimer from './FooterCompanyDisclaimer.vue'
import FooterEmailCollector from './FooterEmailCollector/FooterEmailCollector.vue'
import { useFooterCategories } from './useFooterCategories/useFooterCategories'

const { FF_ENABLE_FOOTER_EMAIL_COLLECTOR = false } = useRuntimeConfig().public

const i18n = useI18n()

const footerCategories = useFooterCategories()
</script>
